import { styled } from '@mui/system';
import { TextField as MuiTextField } from '@mui/material';

export const StyledTextField = styled(MuiTextField)(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
        backgroundColor: theme.palette.common.white,
        borderRadius: theme.spacing(2),
        '& fieldset': {
            borderColor: theme.palette.grey[200],
        },
        '&:hover fieldset': {
            borderColor: theme.palette.primary.main,
        },
        '&.Mui-focused fieldset': { 
            borderColor: theme.palette.primary.main,
        },
    },
}))